import axios from '@/assets/http';

export default {
    get(params) {
        return axios.get(`/api/comment/getTree`, {params: params});
    },
}
